import FormField from "./FormField";
import {
  Autocomplete,
  FormControl,
  FormGroup,
  FormLabel,
  InputAdornment,
  Switch,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DateFormField from "./DateComponent";
import dayjs from "dayjs";
import MDButton from "components/MDButton";
// import DatePicker from "./DatePicker";
// import { Close } from "@mui/icons-material";

const TextField = ({ field }) => {
  const { type, label, name, value, tabIndex, required, disabled, maxLength, prefix, onChange } =
    field;
  const formFieldProps = {
    type,
    label,
    name,
    value,
    ...(required && { required }),
    ...(disabled && { disabled }),
    ...(maxLength && { inputProps: { maxLength } }),
    ...(tabIndex && { inputProps: { tabIndex } }),
    ...(onChange && { onChange }),
    // ...(prefix && {
    //   InputProps: {
    //     startAdornment: (
    //       <InputAdornment position="start">
    //         <span style={{ fontSize: "1rem" }}>{prefix}</span>
    //       </InputAdornment>
    //     ),
    //   },
    // }),
  };
  return <FormField {...formFieldProps} />;
};

const SelectField = ({ field, options, onChange }) => {
  const { name, value, label, required, disabled } = field;
  const autocompleteProps = {
    options,
    // getOptionLabel:(option)=>{{
    //   console.log(option.label)
    //   return option.label
    // }},
    getOptionLabel: (option) => {
      return option.label ?? option;
    },
    isOptionEqualToValue: (option, value) => {
      if (option.value) {
        return option.label === value || option.value === value;
      } else {
        return option === value;
      }
    },
    name,
    value: value === null ? value : value.label ? value.label : value,
    onChange,
    sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
    renderInput: (params) => (
      <FormField
        {...params}
        label={label}
        name={name}
        {...(required && { required })}
        {...(disabled && { disabled })}
      />
    ),
  };
  return <Autocomplete {...autocompleteProps} />;
};

const MultiSelectField = ({ field, options, onChange }) => {
  const { name, value, label, required, disabled } = field;
  const autocompleteProps = {
    multiple:true,
    value,
    options,
    // getOptionLabel:(option)=>{{
    //   console.log(option.label)
    //   return option.label
    // }},
    // getOptionLabel: (option) => {
    //   return option.label ?? option;
    // },
    // isOptionEqualToValue: (option, value) => {
    //   if (option.value) {
    //     return option.label === value || option.value === value;
    //   } else {
    //     return option === value;
    //   }
    // },
    name,
    //value: value === null ? value : value.label ? value.label : value,
    onChange,
    sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
    renderInput: (params) => (
      <FormField
        {...params}
        label={label}
        name={name}
        {...(required && { required })}
        {...(disabled && { disabled })}
      />
    ),
  };
  return <Autocomplete {...autocompleteProps} />;
}

const AsyncSelectField = ({ field, options, onChange, textChange,onInputChange }) => {
  const { name, value, label, required, disabled } = field;
  const autocompleteProps = {
    options,
    getOptionLabel: (option) => {
      return option.label ?? option;
    },
    isOptionEqualToValue: (option, value) => {
      //return true
      if (option.value) {
        return option.label === value || option.value === value;
      } else {
        return option === value;
      }
    },
    name,
    value: value === null ? value : value.label ? value.label : value,
    onChange,
    onInputChange,
    sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
    renderInput: (params) => (
      <FormField
        {...params}
        label={label + " (Search SKU, input at least 4 character)"}
        name={name}
        onChange={textChange}
        {...(required && { required })}
        {...(disabled && { disabled })}
      />
    ),
  };
  return <Autocomplete {...autocompleteProps} />;
}

const SwitchField2 = ({ field, onChange }) => {
  const { label, name, value, tabIndex } = field;
  const switchProps = {
    ...(tabIndex && { inputProps: { tabIndex } }),
  };
  return (
    <MDBox display="flex" sx={{ padding: "0 0 9px 9px" }}>
      <MDBox style={{ width: "40%", whiteSpace: "nowrap" }}>
        <MDTypography variant="button">{label}</MDTypography>
      </MDBox>

      <MDBox lineHeight={0} mx={2}>
        <Switch name={name} checked={value} {...switchProps} onChange={onChange} />
      </MDBox>
    </MDBox>
  );
};

const SwitchField = ({ field, onChange }) => {
  const { label, name, value, tabIndex } = field;
  const switchProps = {
    ...(tabIndex && { inputProps: { tabIndex } }),
  };
  return (
    <FormControl
      sx={{
        margin:"-8px 0 12px 0",
        padding: "8px",
        height: "50px",
        borderRadius: ".375rem",
        border: "1px solid #d6d2da",
      }}
      component="fieldset"
      fullWidth
    >
      <FormLabel
        sx={{ "&.Mui-focused": { color: "#1A73E8" }, padding: "0 4px", fontSize: "12px" }}
        component="legend"
      >
        {label}
      </FormLabel>
      <FormGroup sx={{ marginTop: "-12px" }}>
        <Switch name={name} checked={value} {...switchProps} onChange={onChange} />
      </FormGroup>
    </FormControl>
  );
};

const DatePickerField = ({ field, onChange }) => {
  const { value, label, name, required, disabled } = field;
  const newValue = value === null ? null : dayjs(value);
  const inputProps = {
    format: "DD / MM / YYYY",
    value: newValue,
    onChange: (v) => {
      if (v) {
        onChange(name, dayjs(v).format("YYYY-MM-DD"));
      } else {
        onChange(name, null);
      }
    },
    slotProps: {
      textField: {
        fullWidth: true,
      },
      actionBar: {
        actions: ["clear"],
      },
    },
    ...(disabled && { disabled }),
  };
  return (
    <DateFormField input={inputProps} label={label} name={name} {...(required && { required })} />
  );
};

const LineField = () => {
  return (
    <MDBox sx={{ width: "100%", margin: "7px 0 19px 0", border: "1px solid #d6d9f6" }}></MDBox>
  );
};

const ButtonField = ({ field, onClick }) => {
  const { label, name } = field;
  return (
    <MDButton
      style={{ float: "right", width: "100%" }}
      type="button"
      onClick={onClick}
      variant="gradient"
      color="info"
    >
      {label}
    </MDButton>
  );
};

export { TextField, SelectField, SwitchField, AsyncSelectField, MultiSelectField, DatePickerField, LineField, ButtonField };

// const DateField=({field,onChange,onClear})=>{
//   const{value,label,name,required}=field
//   const inputPropss={
//     value,
//     label,
//     name,
//     InputProps: {
//       endAdornment: (
//         <InputAdornment position="end">
//           {/* <span style={{ fontSize: "1rem" }}>{prefix}</span> */}
//           <IconButton sx={{fontSize:"1rem"}} onClick={onClear}>
//             <Close/>
//             {/* 123 */}
//           </IconButton>
//         </InputAdornment>
//       ),
//     },
//   }
//   return <DatePicker input={inputPropss} {...(required&&{required})} onChange={onChange}/>
// }
